import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { BlockLink } from "@/views/blocks/PageBlock.interface";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationItem',
  props: {
    href: {},
    label: {},
    textColor: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "f520cef4": (_ctx.textColor)
}))



function handleClick(e: MouseEvent) {
    e.preventDefault();
    const targetElement = document.getElementById(__props.href);

    if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.href,
    class: "link-item text-sm/6",
    onClick: handleClick
  }, _toDisplayString(_ctx.label), 9, _hoisted_1))
}
}

})